<div class="asset-cost-table-container" *transloco="let t; prefix: 'costTracking'">
  <div class="table-container">
    <div class="table-inner">
      <table class="asset-cost-table">
        <thead>
          <tr>
            <th class="asset">{{ t('table.asset') }}</th>
            <th class="asset-cost">{{ t('table.assetCost') }}</th>
            <th class="acquisition-type">{{ t('table.acquisitionType') }}</th>
            <th class="cost-ytd">{{ t('table.costYtd') }}</th>
            <th class="cost-per-km">{{ t('table.costPerKm') }}</th>
            <th class="tco">{{ t('table.tco') }}</th>
            <th class="downtime-cost">{{ t('table.downtimeCost') }}</th>
            <th class="disposal-value">{{ t('table.disposalValue') }}</th>
          </tr>
        </thead>
        <tbody>
          @if (isLoading) {
            <tr class="state-row">
              <td colspan="8">
                <div class="spinner-border"></div>
              </td>
            </tr>
          } @else if (!assetCosts.length) {
            <tr class="state-row">
              <td colspan="8">
                <app-empty-state></app-empty-state>
              </td>
            </tr>
          } @else {
            @for(item of assetCosts; track item.assetId) {
              <tr class="asset-row">
                <td class="asset">{{ item.assetName }}</td>
                <td class="asset-cost">{{ formatCost(item.assetCost) }}</td>
                <td class="acquisition-type">{{ item.acquisitionType | lookupLabel:'costTracking.acquisitionTypes' }}</td>
                <td class="cost-ytd">{{ formatCost(item.costYtd) }}</td>
                <td class="cost-per-km">{{ formatCostPerKm(item.costPerKm) }}</td>
                <td class="tco">{{ formatCost(item.tco) }}</td>
                <td class="downtime-cost">{{ formatCost(item.downtimeCost) }}</td>
                <td class="disposal-value">{{ formatCost(item.disposalValue) }}</td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>

    <app-table-footer
      [page]="page"
      [pageSize]="pageSize"
      [totalCount]="totalCount"
      [totalPages]="totalPages"
      [showExport]="false"
      [exportDisabled]="isLoading"
      (pageChange)="goToPage($event)"
      (export)="onExport()">
    </app-table-footer>
  </div>
</div>